const APP_VERSION = '1.10.21';

export default APP_VERSION;
